var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoading(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50 18.75C41.712 18.75 33.7634 22.0424 27.9029 27.9029C22.0424 33.7634 18.75 41.712 18.75 50C18.75 58.288 22.0424 66.2366 27.9029 72.0971C33.7634 77.9576 41.712 81.25 50 81.25C58.288 81.25 66.2366 77.9576 72.0971 72.0971C77.9576 66.2366 81.25 58.288 81.25 50C81.25 41.712 77.9576 33.7634 72.0971 27.9029C66.2366 22.0424 58.288 18.75 50 18.75ZM6.25 50C6.25 25.8375 25.8375 6.25 50 6.25C74.1625 6.25 93.75 25.8375 93.75 50C93.75 74.1625 74.1625 93.75 50 93.75C25.8375 93.75 6.25 74.1625 6.25 50Z",
    fill: "#67AF5C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.9999 18.75C41.9432 18.7328 34.1946 21.8445 28.3875 27.4292C27.1844 28.5415 25.5927 29.137 23.955 29.0873C22.3173 29.0377 20.7646 28.3469 19.6312 27.1638C18.4978 25.9806 17.8743 24.3997 17.8949 22.7614C17.9156 21.1231 18.5787 19.5584 19.7416 18.4042C27.8751 10.5902 38.7211 6.23357 49.9999 6.25005C51.6576 6.25005 53.2473 6.90853 54.4194 8.08063C55.5915 9.25273 56.2499 10.8424 56.2499 12.5C56.2499 14.1577 55.5915 15.7474 54.4194 16.9195C53.2473 18.0916 51.6576 18.75 49.9999 18.75Z",
    fill: "#67AF5C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading);
export default __webpack_public_path__ + "static/media/loading.174ab8861be7017a8ec2feea3d8c6731.svg";
export { ForwardRef as ReactComponent };